import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgStackedBarChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 38.3986H18.58V58.8779C18.58 61.7055 16.2878 63.9978 13.4602 63.9978H5.11983C2.29223 63.9978 0 61.7055 0 58.8779V38.3986Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.4185 46.9318H63.9985V58.878C63.9985 61.7056 61.7063 63.9979 58.8787 63.9979H50.5383C47.7107 63.9979 45.4185 61.7056 45.4185 58.878V46.9318Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 13.6529C0 10.8253 2.29223 8.53303 5.11983 8.53303H13.4602C16.2878 8.53303 18.58 10.8253 18.58 13.6529V23.4659H0V13.6529Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.4185 24.3191C45.4185 21.4915 47.7107 19.1992 50.5383 19.1992H58.8787C61.7063 19.1992 63.9985 21.4915 63.9985 24.3191V31.9988H45.4185V24.3191Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 23.4659H18.58V38.3986H0V23.4659Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.4185 31.9988H63.9985V46.9318H45.4185V31.9988Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7093 34.1322H41.2893V58.878C41.2893 61.7056 38.9971 63.9979 36.1695 63.9979H27.8291C25.0015 63.9979 22.7093 61.7056 22.7093 58.878V34.1322Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7089 5.11971C22.7089 2.2921 25.0012 -0.00012207 27.8288 -0.00012207H36.1691C38.9967 -0.00012207 41.289 2.2921 41.289 5.11971V14.9327H22.7089V5.11971Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7089 14.9327H41.289L41.2893 34.1322H22.7093L22.7089 14.9327Z",
			fill: "#BFDBFE"
		})
	]
});
export default SvgStackedBarChart;
